import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";
import { Leaf } from "lucide-react";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back, admin.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-88px)] flex items-center justify-center paper-texture px-5">
      <div className="w-full max-w-md bg-forest text-ivory rounded-2xl p-10 border border-forest/50 shadow-2xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-full overflow-hidden ring-1 ring-ivory/20"><img src="/images/logo.png" alt="" className="w-full h-full object-cover" /></div>
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-mustard">Admin Panel</div>
            <div className="font-serif text-xl">LSP Journal</div>
          </div>
        </div>

        <h1 className="font-serif text-3xl mb-2">Sign in.</h1>
        <p className="text-ivory/70 text-[14px] mb-6 flex items-center gap-2"><Leaf className="w-4 h-4 text-mustard" /> Authorized personnel only</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="text-ivory/80">Email</Label>
            <Input id="email" data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-ivory/10 border-ivory/20 text-ivory mt-2" required />
          </div>
          <div>
            <Label htmlFor="password" className="text-ivory/80">Password</Label>
            <Input id="password" data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-ivory/10 border-ivory/20 text-ivory mt-2" required />
          </div>
          <button type="submit" data-testid="admin-login-submit" disabled={busy} className="btn-pill bg-mustard text-forest hover:bg-mustard/90 w-full justify-center disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
